import React, { useState } from 'react';
import { CreditCard, ArrowRight, X } from 'lucide-react';
import PaymentModal from './PaymentModal';

const PaymentBanner = () => {
  const [showModal, setShowModal] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const handlePaymentSuccess = () => {
    // After payment, the PaymentModal's onSuccess will open calendar in LandingPage
    // We keep this here as a no-op since banner modal is standalone
  };

  if (dismissed) return null;

  return (
    <>
      <div className="w-full bg-gradient-to-r from-emerald-700 via-teal-600 to-emerald-700 text-white py-4 px-4 relative shadow-lg">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6">
          {/* Icon */}
          <div className="flex-shrink-0 bg-white/20 rounded-full p-2">
            <CreditCard className="h-5 w-5 text-white" />
          </div>

          {/* Text */}
          <p className="text-sm sm:text-base font-medium text-center sm:text-left">
            <span className="font-bold">Ready to transform your life?</span>{' '}
            <span className="text-emerald-100">Book a paid consultation session — complete your payment and reserve your slot.</span>
          </p>

          {/* CTA Button */}
          <button
            onClick={() => setShowModal(true)}
            className="flex-shrink-0 flex items-center gap-2 bg-white text-emerald-700 hover:bg-emerald-50 font-semibold px-5 py-2 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105 text-sm"
          >
            Book a Consultation
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>

        {/* Dismiss */}
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 hover:text-white transition-colors"
          aria-label="Dismiss banner"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      {/* Payment Modal */}
      <PaymentModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={handlePaymentSuccess}
      />
    </>
  );
};

export default PaymentBanner;
